import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import type { OrderSearchInput } from '@repo/api-contract';
import { useTranslation } from 'react-i18next';
import {
  searchOrders,
  setSearchBy,
} from '../../../../state/orderSearchModalSlice';
import { useDispatch, useSelector } from '../../../../state';

export default function SearchByDropdown() {
  const dispatch = useDispatch();
  const { t: tGC } = useTranslation([], { keyPrefix: 'team.Global.Common' });
  const { t: tGT } = useTranslation([], { keyPrefix: 'team.Global.Tables' });

  const { searchInput, searchBy } = useSelector(
    (store) => store.orderSearchModalSlice,
  );

  const handleChange = (event: SelectChangeEvent) => {
    const searchValue = event.target.value as OrderSearchInput['searchBy'];
    dispatch(setSearchBy(searchValue));
    const payload: OrderSearchInput = {
      query: searchInput,
      searchBy: searchValue,
      size: 100,
      page: 0,
    };
    dispatch(searchOrders(payload));
  };

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">
          {tGT('Search By')}
        </InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={searchBy}
          label={tGT('Search By')}
          onChange={handleChange}
        >
          <MenuItem value={'orderCode'}>{tGC('Sales Order Code')}</MenuItem>
          <MenuItem value={'companyName'}>{tGC('Company Name')}</MenuItem>
          <MenuItem value={'customerId'}>{tGC('Customer ID')}</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}
